/**
 * SmartMonkey Dashboard
 *
 * Copyright © 2018-present SmartMonkey Scalable Computing S.L.. All rights reserved.
 *
 * @license This file is covered by the LICENSE.txt file in the root directory of this source tree.
 */
import * as mixpanel from 'mixpanel-browser';
import { configuration } from './configuration';
import { setStorage, getStorage } from './storageService';

export const Events = {
    HOME_CREATE_ACCOUNT: 'HOME_CREATE_ACCOUNT',
    HOME_LOGIN: 'HOME_LOGIN',
    HOME_LOGOUT: 'HOME_LOGOUT',
    HOME_TO_CONSOLE: 'HOME_TO_CONSOLE',
    HOME_OPEN_DOCUMENTATION: 'HOME_OPEN_DOCUMENTATION',
    CONSOLE_LOGOUT: 'CONSOLE_LOGOUT',
    CONSOLE_KEYS: 'CONSOLE_KEYS',
    CONSOLE_KEYS_DETAIL: 'CONSOLE_KEYS_DETAIL',
    CONSOLE_KEYS_QUOTA_SAVE: 'CONSOLE_KEYS_QUOTA_SAVE',
    CONSOLE_KEYS_OPEN_KEY_DETAILS: 'CONSOLE_KEYS_OPEN_KEY_DETAILS',
    CONSOLE_ACTIVITY: 'CONSOLE_ACTIVITY',
    CONSOLE_ACTIVITY_CHANGE_DAYS_FILTER: 'CONSOLE_ACTIVITY_CHANGE_DAYS_FILTER',
    CONSOLE_ACTIVITY_CHANGE_REQUESTS_FILTER: 'CONSOLE_ACTIVITY_CHANGE_REQUESTS_FILTER',
    CONSOLE_ACTIVITY_VIEW_DETAIL: 'CONSOLE_ACTIVITY_VIEW_DETAIL',
    CONSOLE_ACTIVITY_DETAILS_SHOW_DETAILS: 'CONSOLE_ACTIVITY_DETAILS_SHOW_DETAILS',
    CONSOLE_USERS: 'CONSOLE_USERS',
    USER_CREATE_NEW_PASSWORD: 'USER_CREATE_NEW_PASSWORD',
    USER_VALIDATE_NEW_PASSWORD_TOKEN: 'USER_VALIDATE_NEW_PASSWORD_TOKEN',
    USER_RESEND_VERIFICATION_MAIL: 'USER_RESEND_VERIFICATION_MAIL',
    HOME_UPGRADE_ACCOUNT: 'HOME_UPGRADE_ACCOUNT',
    CONTACT_US: 'CONTACT_US',
};


const token = configuration.MIXPANEL_API_KEY;

class Mixpanel {
    initialized: boolean = false;

    token() {
        return token;
    }

    init() {
        mixpanel.init(token);
        this.initialized = true;
    }

    identify(userId) {
        if (!this.initialized) {
            this.init();
        }
        setStorage('user', userId);
        mixpanel.register({ '$email': userId, '$name': userId });
        mixpanel.identify(userId);
    }

    track(message: string, attributes: Object) {
        const user = getStorage('user');
        if (user) {
            this.identify(user);
        }
        if (!this.initialized) {
            this.init();
        }
        mixpanel.track(message, attributes);
    }

    send(f: (mixpanel) => void) {
        if (!this.initialized) {
            this.init();
        }
        if (f) {
            f(mixpanel);
        }
    }
}

export default new Mixpanel();
